import { useReveal } from "@/hooks/useReveal";

const items = [
  {
    icon: "ri-microscope-line",
    title: "科學修復",
    desc: "以離子紅光細胞再生技術為核心，結合海洋生物製劑，安全溫和適用孕婦與幼兒。",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "國際教育",
    desc: "串聯亞洲與歐美專家資源，建立系統化的病變皮膚修復與美業教育認證體系。",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "公益使命",
    desc: "自 2016 年起於兒童康復中心、福利院持續舉辦公益活動，幫助逾十萬名患者康復。",
  },
  {
    icon: "ri-award-line",
    title: "臨床權威",
    desc: "與央視深度合作，門店遍布全國，上萬家連鎖機構採用 ISHB 產品與技術。",
  },
];

export default function Philosophy() {
  const { ref, visible } = useReveal<HTMLDivElement>();

  return (
    <section id="philosophy" className="py-20 md:py-28 bg-[#f4f8f5]">
      <div ref={ref} className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          className={`text-center mb-14 transition-all duration-700 ease-out ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="inline-block px-5 py-1.5 rounded-full bg-brand-600 text-white text-sm tracking-wider">創校理念</div>
          <h2 className="mt-6 font-serif text-3xl md:text-5xl font-bold text-brand-800">
            以匠心發現價值，將卓越醫粹無限放大。
          </h2>
          <div className="mt-6 max-w-2xl mx-auto space-y-4 text-brand-700/80 leading-relaxed">
            <p>
              我們立足深厚的中華傳統醫學智慧，融合現代前沿科學技術，致力打破地域與行業界限，將這份東方醫學精粹傳揚至世界各地。
            </p>
            <p>
              在深耕臨床修復實踐的同時，ISHB 亦專注於專業專科技術培訓，賦能更多從業者掌握卓越手藝，用一技之長，幫助全球更多生命活出健康與自信。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((it, i) => (
            <div
              key={it.title}
              style={{ transitionDelay: `${i * 120}ms` }}
              className={`transition-all duration-700 ease-out ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
            >
              <div className="h-full bg-white rounded-lg p-7 border border-brand-100 hover:border-brand-300 transition group">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-brand-50 text-brand-600 group-hover:bg-brand-600 group-hover:text-white transition">
                  <i className={`${it.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-5 text-lg font-semibold text-brand-800">{it.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-brand-900/70">{it.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}